import React, { PropsWithChildren } from "react";
import { mergeStyleSets, useTheme } from "@fluentui/react";

import LinkBase from "./base/Link.base";

interface UrlProps {
    href?: string;
}

const LinkRegular: React.FunctionComponent<UrlProps> = (props: PropsWithChildren<UrlProps>) => {
    const { children, href = `` } = props;
    const theme = useTheme();

    const linkStyles = mergeStyleSets({
        linkRoot: {
            color: theme.palette.themePrimary,
            textDecoration: `none`,
            selectors: {
                ":hover": {
                    color: theme.palette.themeTertiary,
                },
            },
        },
    });

    return (
        <LinkBase theme={theme} className={linkStyles.linkRoot} href={href}>
            {children}
        </LinkBase>
    );
};

export default LinkRegular;
